import { useEffect, useState } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Lottie from "lottie-react";
import loaderjson from "../utils/mainLoader.json";
import loaderjsonLight from "../utils/mainLoaderLight.json";

const getTheme = () => {
  return document.body.classList.contains("dark") ? "dark" : "light";
};

const PersistSignIn = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const refresh = useRefreshToken();
  const { accessToken } = useSelector((state) => state.auth);
  const theme = getTheme();
  const animationData = theme === "dark" ? loaderjsonLight : loaderjson;
  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (error) {
        console.log("Error refreshing token:", error);
      } finally {
        isMounted && setIsLoading(false);
      }
    };
    verifyRefreshToken();

    return () => (isMounted = false);
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <div className="fixed inset-0 z-[9999] bg-maastrichtBlue dark:bg-lmaastrichtBlue opacity-1 flex justify-center items-center">
            <div className="z-[99999]">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ width: 200, height: 200 }}
              />
            </div>
          </div>
        </>
      ) : accessToken ? (
        <Outlet />
      ) : (
        <>
          <Navigate to="signin" state={{ from: location }} replace />
        </>
      )}
    </>
  );
};

export default PersistSignIn;
